
import http from "../../shared/integrationsApi"
import Vue from "vue"
import { uniq } from 'lodash'

const integrations = {
    state: {
        items: [],
        available: false,
        badges: {}
    },
    actions: {
        fetchIntegrations({commit, state}, force) {
            return new Promise((resolve, reject) => {
                if (state.items.length > 0 && !force) {
                    resolve(state.items)
                    return
                }

                http.get("integrations")
                .then((resp) => {
                    if (resp) {
                        commit('SET_INTEGRATIONS', resp.data)
                    } else {
                        reject(new Error("unavailable"))
                    }

                    resolve()
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchIntegrationsExplore({commit}) {
            return new Promise((resolve, reject) => {
                http.get("integrations/explore")
                .then((resp) => {
                    if (resp) {
                        resolve(resp.data)
                    } else {
                        reject(new Error("unavailable"))
                    }
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        activateIntegration({commit}, integration) {
            return new Promise((resolve, reject) => {
                http.post(`/integration/${integration.id}/activate`).then(resp => {
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            })
        },

        deactivateIntegration({commit}, integration) {
            return new Promise((resolve, reject) => {
                http.post(`integration/${integration.id}/deactivate`).then(resp => {
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            });
        },

        updateIntegrationOnboarding({commit}, {integrationId, step, data}) {
            return new Promise((resolve, reject) => {
                http.post(`/integration/${integrationId}/onboarding`, {
                    step: step,
                    data: data
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        
    },
    mutations: {
        SET_INTEGRATIONS (state, ints) {   
            Vue.set(state, "items", ints || [])
        },

        SET_AVAILABILITY (state, available) {
            state.available = available
        },

        ADD_INTEGRATION (state, int) {
            state.items.push(int)
        },

        REMOVE_INTEGRATION (state, int) {
            state.items = state.items.filter(i => {
                return i.id != int.id
            })
        },

        PAUSE_INTEGRATION_ONBOARDING (state, data) {
            state.pausedOnboarding.push({
                ...data,
                pausedAt: new Date().toISOString()
            })

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_INTEGRATION_ONBOARDING (state, id) {
            state.pausedOnboarding = state.pausedOnboarding.filter(i => {
                return i.id != id && i.project_uuid == state.currentProject
            })

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_ONBOARDING_ALL (state) {
            Vue.set(state, 'pausedOnboarding', [])
            localStorage.setItem("pausedOnboarding", JSON.stringify([]))
        },

        INTEGRATION_ONBOARDED (state, id) {
            const items = state.items.map(i => {
                if (i.id == id) {
                    i.onboarded = true
                }

                return i
            })

            Vue.set(state, 'items', items)
        },

        SET_INTEGRATION_BADGE (state, payload) {
            Vue.set(state.badges, payload.id, payload.count)
        }
    },
    getters: {
        getIntegrations(state) {
            return state.items || []
        },

        isIntegrationActive: (state) => (id) => {
            let f = state.items.find(i => {
                return i.id == id
            })

            if (f !== undefined && f.status !== undefined) {
                return f.status === 'active'
            }

            return f !== undefined
        },

        getActiveIntegrations(state) {
            return state.items.filter(i => {
                return i.status === 'active'
            })
        },

        getIntegrationByID: (state) => (id) => {
            return state.items.find(i => {
                return i.id == id
            })
        },

        integrationsAvailable(state) {
            return state.available
        },

        getIntegrationBadge: (state) => function(id) {
            return state.badges[id] || 0
        }
    }
  }

export default integrations